export default "/assets/images/column-image4.bb517aa530ecded7.png";